import { inject, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MsalSilentRedirectComponent } from './msal-silent-redirect.component';
import { msalSessionResolver } from './shared/msal/services/msal-session.resolver';
import { MsalCallbackComponent } from './msal-callback.component';
import { authenticatedGuard } from './guards/auth/auth.guard';
import { OrganizationConfigService } from './shared/organization/services/organizationConfig.service';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'msal-callback',
    component: MsalCallbackComponent,
  },
  {
    path: 'msal-silent-redirect',
    component: MsalSilentRedirectComponent,
  },
  {
    path: 'dashboard',
    canActivate: [authenticatedGuard],
    resolve: {
      msalSession: msalSessionResolver,
    },
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        m => m.DashboardModule
      ),
  },
  {
    path: 'config',
    canActivate: [authenticatedGuard],
    resolve: {
      msalSession: msalSessionResolver,
    },
    loadChildren: () =>
      import('./modules/config/config.module').then(m => m.ConfigModule),
  },
  {
    path: 'logout',
    loadChildren: () =>
      import('./modules/logout/logout.module').then(m => m.LogoutModule),
  },
  {
    path: '**',
    redirectTo: () => {
      const organizationConfigService = inject(OrganizationConfigService);

      return organizationConfigService.organization.loggedInRedirectToUrl;
    },
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
